module.exports = __webpack_public_path__ + "img/icon35.bede628a.png";